import { defineModal, confirmModalPayloadSchema, type ModalRegistryMap } from '@noor/lib';
import {
  PromotionModal,
  addPromotionPayloadSchema,
  editPromotionPayloadSchema,
} from '@/features/promotion-form';
import {
  UserFormModal,
  addUserPayloadSchema,
  editUserPayloadSchema,
} from '@/features/user-form';
import {
  VenueHoursModal,
  editVenueHoursPayloadSchema,
} from '@/features/venue-hours-form';
import {
  ProductModal,
  addProductPayloadSchema,
  editProductPayloadSchema,
} from '@/features/upsert-product';
import {
  BranchModal,
  addBranchPayloadSchema,
  editBranchPayloadSchema,
} from '@/features/branch-form';
import {
  ProviderImportModal,
  providerImportModalPayloadSchema,
} from '@/features/provider-import';
import { ConfirmModal } from './confirm-modal';

/**
 * Concrete modal registry: maps every registered modal id to its definition
 * (`{ component, schema }`). Lives in `app` because it imports feature modals —
 * `@noor/lib` only defines the contract. Register a modal by
 * declaration-merging `ModalRegistry` in the feature's `index.ts` and adding a
 * `defineModal(id, …)` entry here — `ModalRegistryMap` is exhaustive, so a
 * missing/mismatched entry is a compile error.
 */
export const modalRegistry: ModalRegistryMap = {
  confirm: defineModal('confirm', {
    component: ConfirmModal,
    schema: confirmModalPayloadSchema,
  }),
  'add-promotion': defineModal('add-promotion', {
    component: PromotionModal,
    schema: addPromotionPayloadSchema,
  }),
  'edit-promotion': defineModal('edit-promotion', {
    component: PromotionModal,
    schema: editPromotionPayloadSchema,
  }),
  'add-user': defineModal('add-user', {
    component: UserFormModal,
    schema: addUserPayloadSchema,
  }),
  'edit-user': defineModal('edit-user', {
    component: UserFormModal,
    schema: editUserPayloadSchema,
  }),
  'edit-venue-hours': defineModal('edit-venue-hours', {
    component: VenueHoursModal,
    schema: editVenueHoursPayloadSchema,
  }),
  'add-product': defineModal('add-product', {
    component: ProductModal,
    schema: addProductPayloadSchema,
  }),
  'edit-product': defineModal('edit-product', {
    component: ProductModal,
    schema: editProductPayloadSchema,
  }),
  'add-branch': defineModal('add-branch', {
    component: BranchModal,
    schema: addBranchPayloadSchema,
  }),
  'edit-branch': defineModal('edit-branch', {
    component: BranchModal,
    schema: editBranchPayloadSchema,
  }),
  'provider-import-job': defineModal('provider-import-job', {
    component: ProviderImportModal,
    schema: providerImportModalPayloadSchema,
  }),
};
